import { oauthSessionAPI } from './api';
import {
  animateOauthFailed,
} from '../../animations/animate';

async function oauthSession (params = {}) {
    
    const env = this.env;
    const appStore = this.env.appStore;
    const errorsStore = this.env.errorsStore;
    const statesStore = this.env.uiStatesStore;
    const sessionId = params.sessionId || appStore.oauthSessionId;
    const apiKey = appStore.widgetSettings.apikey;
    const res = await oauthSessionAPI({
        apiKey,
        body: {},
        sessionId,
        traceId: env.traceId,
        store: this,
    });

    if (res.data.oauthResult !== 'succeeded') {
      errorsStore.dispatch({ oauthErrorKey: 'OAUTH_FAILED', selectedCalendar: appStore.selectedCalendar });
      animateOauthFailed(this.env);
      return;
    } 
    
    appStore.oauthEmail = res.data.googleAccountEmail;
    if (!appStore.oauthEmail) {
      appStore.oauthEmail = res.data.outlookAccountEmail;
    }
 
    appStore.icsFilename = res.data?.icsFilename;
    appStore.oauthTokenId = res.data?.oauthTokenId;
    appStore.selectedCalendar = statesStore.selectedCalendar;
    this.subscriberActive();
}

export default oauthSession;

/* 

FAILED on Google and Outlook Oauth

{
  "icsFilename": "Phil LLCsss",
  "oauthSessionId": "758e183e62504c12a8eb9e5353645642",
  "status": 200,
  "statusLong": "OK",
  "securityTokenEnabled": false
}

SUCCESS ON Google and Outlook Oauth
{
  "icsFilename": "English Premier League",
  "oauthSessionId": "5f5c23e1495f4a079111b5e5eab762ef",
  "oauthTokenId": "DQC2uzjdvE0",
  "oauthResult": "succeeded",
  "outlookAccountEmail": "jack.happy.writing@outlook.com",
  "status": 200,
  "statusLong": "OK",
  "securityTokenEnabled": false
}

*/